export default "__VITE_ASSET__iBtgmVgT__"